import React, { useState, useEffect } from "react";

import { Toast } from "../CustomComponent/toast";

import Footer from "../../Components/Footer/footer";
import performRequest from "../../APIs/request";

import { useDispatch, useSelector } from "react-redux";
import LoadingPage from "../../Components/layouts/loading";
import { useNavigate } from "react-router";
import Pagination from "../../Components/layouts/pagination";
import SimpleButton from "../../Components/layouts/simple_button";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import {
  setCurrentPage,
  setReduxFilters,
} from "../../Redux/Pagination & Filters/allShortlistRequestFiltersReducer";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
function countPastDays(dateString) {
  if (dateString === null) {
    return <span className="badge bg-red-lt">Not active</span>;
  }
  const pastDate = new Date(dateString);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const timeDifference = today - pastDate;
  let daysPast = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  if (daysPast <= 0) {
    daysPast = 1;
  }
  if (daysPast === 1) {
    return <span className="badge bg-green-lt">Active Today</span>;
  }
  if (daysPast > 30) {
    return <span className="badge bg-red-lt">Not active</span>;
  }
  return (
    <span className="badge bg-yellow-lt">{`Active ${daysPast} days ago`}</span>
  );
}
const getStatusBadge = (status) => {
  if (status === "hire") {
    return <span className="badge bg-green-lt">Hired</span>;
  }
  if (status === "negotiate") {
    return <span className="badge bg-yellow-lt">Negotiate</span>;
  }
  if (status === "reject") {
    return <span className="badge bg-red-lt">Reject</span>;
  }
};
const Shortlistrequest = () => {
  const [interviewData, setInterviewData] = useState();
  const [loading, setLoading] = useState(true);
  const [filterData, setFilterData] = useState([]);
  const navigate = useNavigate();
  const paginationStore = useSelector(
    (store) => store.allShortlistRequestFilter
  );
  const [page, setCurrPage] = useState(paginationStore?.currentPage || 1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState(paginationStore?.filters);
  const [refresh, setRefresh] = useState(false);

  const dispatch = useDispatch();
  const getShortlistRequests = () => {
    performRequest(
      "GET",
      getFilteredURL(
        "/applyedcandidate/getcandidatesappliedtojobs",
        paginationStore.currentPage,
        paginationStore.filters
      )
    )
      .then((res) => {
        if (res.status === 200) {
          setFilterData(res.data?.data);
          setTotalPages(Math.ceil(res?.data?.totalData / 50));
        } else {
          Toast("error", "Server Error");
        }
      })
      .catch((err) => {
        console.error("Error", err);
      })
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    getShortlistRequests();
  }, [paginationStore?.currentPage, refresh]);

  useEffect(() => {
    setCurrPage(paginationStore?.currentPage);
    setShowPage(Math.floor((paginationStore?.currentPage - 1) / 5) * 5 + 1);
  }, [paginationStore?.currentPage]);
  const setPage = (p) => {
    dispatch(setCurrentPage(p));
  };
  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header">
            <h2>All Shortlist Requests</h2>
          </div>
          <div className="page-body">
            <div className="card">
              <div className="row row deck m-3">
                <h3>Filter result</h3>{" "}
                <div className=" col-lg-3 col-12 mb-2">
                  <DynamicFilterInput
                    label="Search name /mobile:"
                    value={filters.nameOrMobile}
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        nameOrMobile: e.target.value,
                      });
                      dispatch(
                        setReduxFilters({
                          ...filters,
                          nameOrMobile: e.target.value,
                        })
                      );
                    }}
                    placeholder="search here..."
                  />
                </div>{" "}
                <div className="col-lg-3 col-12 mb-2">
                  <DynamicFilterSelect
                    label="Sort by skills:"
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        sortByskills: e.target.value,
                      });
                      dispatch(
                        setReduxFilters({
                          ...filters,
                          sortByskills: e.target.value,
                        })
                      );
                    }}
                    value={filters.sortByskills}
                  >
                    <option value="">select all</option>
                    <option value="ASC">Low To High</option>
                    <option value="DESC">High To Low</option>
                  </DynamicFilterSelect>
                </div>
                <div className="col-lg-3 col-12 mb-2">
                  <DynamicFilterSelect
                    label="Sort by active date:"
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        sortByActiveDate: e.target.value,
                      });
                      dispatch(
                        setReduxFilters({
                          ...filters,
                          sortByActiveDate: e.target.value,
                        })
                      );
                    }}
                    value={filters.sortByActiveDate}
                  >
                    <option value="">select all</option>
                    <option value="ASC">Low To High</option>
                    <option value="DESC">High To Low</option>
                  </DynamicFilterSelect>
                </div>
                <div className="col-lg-3 col-12 mb-2">
                  <DynamicFilterSelect
                    label="select by shortlist status:"
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        shortlistStatus: e.target.value,
                      });
                      dispatch(
                        setReduxFilters({
                          ...filters,
                          shortlistStatus: e.target.value,
                        })
                      );
                    }}
                    value={filters.shortlistStatus}
                  >
                    <option value="">select all</option>
                    <option value="shortlisted">Shortlisted</option>
                    <option value="shortlist-requested">
                      Shortlist Requested
                    </option>
                    <option value="pending">Pending</option>
                  </DynamicFilterSelect>
                </div>
                <div className="col-lg-3 col-12 mb-2">
                  <DynamicFilterSelect
                    label="select by interview-scheduled status:"
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        interviewScheduled: e.target.value,
                      });
                      dispatch(
                        setReduxFilters({
                          ...filters,
                          interviewScheduled: e.target.value,
                        })
                      );
                    }}
                    value={filters.interviewScheduled}
                  >
                    <option value="">select all</option>
                    <option value="interview-scheduled">
                      Interview Scheduled
                    </option>
                    <option value="pending">Pending</option>
                  </DynamicFilterSelect>
                </div>
                <div className="col-lg-3 col-12 mb-2">
                  <DynamicFilterSelect
                    label="select by hired status:"
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        hiredStatus: e.target.value,
                      });
                      dispatch(
                        setReduxFilters({
                          ...filters,
                          hiredStatus: e.target.value,
                        })
                      );
                    }}
                    value={filters.hiredStatus}
                  >
                    <option value="">select all</option>
                    <option value="hired">Hired</option>
                    <option value="negotiate">Negotiate</option>
                    <option value="rejected">Rejected</option>
                    <option value="no-action">No-Action Taken</option>
                  </DynamicFilterSelect>
                </div>
                <div className="col-lg-3 col-12 mb-2">
                  <div className="row mt-2">
                    <div className="col-6">
                      <SimpleButton
                        onClick={() => {
                          dispatch(setCurrentPage(1));
                          setRefresh(!refresh);
                        }}
                        className="btn btn-primary w-100"
                        buttonText={"Apply Filters"}
                      />
                    </div>
                    <div className="col-6">
                      <SimpleButton
                        onClick={() => {
                          dispatch(
                            setReduxFilters({
                              nameOrMobile: "",
                              sortByskills: "",
                              sortByActiveDate: "",
                              shortlistStatus: "",
                              interviewScheduled: "",
                              hiredStatus: "",
                            })
                          );
                          setFilters({
                            nameOrMobile: "",
                            sortByskills: "",
                            sortByActiveDate: "",
                            shortlistStatus: "",
                            interviewScheduled: "",
                            hiredStatus: "",
                          });

                          setRefresh(!refresh);
                        }}
                        className="btn btn-secondary w-100"
                        buttonText={"Reset Filters"}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <table className="table table-vcenter table-mobile-md card-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Contact Details</th>
                      <th>Total Skills & Total Applications</th>
                      <th>Shortlist Status</th>
                      <th>Interview Status</th>
                      <th>Hire Status</th>
                      <th className="w-1">actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filterData &&
                      filterData?.map((el, index) => {
                        return (
                          <tr key={index}>
                            <td data-label="Name">
                              <div className="d-flex py-1 align-items-center">
                                <span className="avatar me-2">
                                  <img
                                    src={
                                      el?.usermodel?.profilePicture ||
                                      el?.usermodel?.resumemodel
                                        ?.personalDetails?.[0]
                                        ?.profilePicture ||
                                      "https://png.pngtree.com/element_our/20190601/ourmid/pngtree-address-book-icon-image_1347894.jpg"
                                    }
                                    alt=""
                                    srcSet=""
                                  />
                                </span>
                                <div className="flex-fill">
                                  <div className="font-weight-medium">
                                    {el?.usermodel?.fullName}
                                  </div>
                                  <div className="fs-5">
                                    {countPastDays(el?.usermodel?.lastLogin)}
                                  </div>
                                </div>
                              </div>
                            </td>

                            <td data-label="Contact Details">
                              <div>{el?.usermodel?.contactNumber}</div>
                              <div className="text-secondary">
                                {el?.usermodel?.email}
                              </div>
                            </td>
                            <td data-label="Total Skills & Total Applications">
                              <div>
                                Skills badges:{" "}
                                {el?.usermodel?.resumemodel?.skills?.length ||
                                  0}
                              </div>
                              {/* <div className="text-secondary">
                                Applications:{" "}
                                {data.candidateapplyandshortlists?.length || 0}
                              </div> */}
                            </td>
                            <td data-label="Shortlist Status">
                              {el?.shortlistStatus ? (
                                <span className="status status-green">
                                  Shortlisted
                                </span>
                              ) : (
                                <span className="status status-red">
                                  status pending
                                </span>
                              )}
                            </td>
                            <td data-label="Interview Status">
                              {el?.interviewSchedule &&
                              Object.keys(el?.interviewSchedule).length > 0 ? (
                                <span
                                  data-bs-toggle="modal"
                                  data-bs-target="#modal-team"
                                  onClick={() =>
                                    setInterviewData(el.interviewSchedule)
                                  }
                                  className="btn status status-green"
                                >
                                  view Schedule
                                </span>
                              ) : (
                                <span className="status status-red">
                                  Pending
                                </span>
                              )}
                            </td>
                            <td>
                              {el.hireStatus
                                ? getStatusBadge(el.hireStatus)
                                : "N/A"}
                            </td>
                            <td>
                              <div className="btn-list flex-nowrap">
                                <div className="dropdown">
                                  <button
                                    className="btn dropdown-toggle align-text-top"
                                    data-bs-toggle="dropdown"
                                  >
                                    Actions
                                  </button>
                                  <div className="dropdown-menu dropdown-menu-end">
                                    <button
                                      className="dropdown-item"
                                      onClick={() => {
                                        if (el?.usermodel.resumemodel?.id) {
                                          navigate(`/view-candidate/${el?.id}`);
                                        } else {
                                          alert(
                                            "Resume not field by candidate"
                                          );
                                        }
                                      }}
                                    >
                                      View resume
                                    </button>

                                    <button
                                      className="dropdown-item"
                                      onClick={() =>
                                        navigate(
                                          `/view-jobs/${el?.jobsmodel?.id}`
                                        )
                                      }
                                    >
                                      View Job Details
                                    </button>
                                    <button
                                      className="dropdown-item"
                                      onClick={() =>
                                        navigate(
                                          `/company-details/${el?.jobsmodel?.employeronboardingmodel?.id}`
                                        )
                                      }
                                    >
                                      View Company Details
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>{" "}
              <div>
                <Pagination
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  pageDatalength={filterData?.length}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal modal-blur fade"
          id="modal-team"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Schedule Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <div className="card-body">
                  <div className="mb-3 row">
                    <label className="w-33 form-label col-3">
                      Date of Interview:
                    </label>
                    <div className="w-100 col ">{interviewData?.date}</div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-33 form-label col-">
                      Interview Time:
                    </label>
                    <div className="w-100 col ">{interviewData?.time}</div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-33 form-label col-">
                      Interview Mode:
                    </label>
                    <div className="w-100 col ">
                      {interviewData?.modeofInterview}
                    </div>
                  </div>
                  {interviewData?.modeofInterview ===
                    "telephonic interview" && (
                    <div className="mb-3 row">
                      <label className="w-33 form-label col-">
                        Contact Number:
                      </label>
                      <div className="w-100 col ">
                        {interviewData?.contactNumber}
                      </div>
                    </div>
                  )}
                  {interviewData?.modeofInterview === "walk-in interview" && (
                    <div className="mb-3 row">
                      <label className="w-33 form-label col-">
                        Interview Address:
                      </label>
                      <div className="w-100 col ">{interviewData?.address}</div>
                    </div>
                  )}
                  {interviewData?.modeofInterview === "video interview" && (
                    <div className="mb-3 row">
                      <label className="w-33 form-label col-">
                        Meeting Link:
                      </label>
                      <div className="w-100 col ">
                        {interviewData?.meetLink}
                      </div>
                    </div>
                  )}
                  {interviewData?.contactPersonName && (
                    <div className="mb-3 row">
                      <label className="w-33 form-label col-">
                        Contact Person:
                      </label>
                      <div className="w-100 col ">
                        {interviewData?.contactPersonName}
                      </div>
                    </div>
                  )}
                  {interviewData?.contactPersonNumber && (
                    <div className="mb-3 row">
                      <label className="w-33 form-label col-">
                        Contact Person Number:
                      </label>
                      <div className="w-100 col ">
                        {interviewData?.contactPersonNumber}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn me-auto"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Shortlistrequest;
